// Generated by purs version 0.15.16
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Concur_React_Props from "../Concur.React.Props/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
import * as Internal_Util from "../Internal.Util/index.js";
import * as Translate from "../Translate/index.js";
import * as Web_File_File from "../Web.File.File/index.js";
import * as Widgets_Confirmation from "../Widgets.Confirmation/index.js";
import * as Widgets_Upload from "../Widgets.Upload/index.js";
var multiAlternativeWidget = /* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray);
var div = /* #__PURE__ */ Concur_React_DOM.div(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var a = /* #__PURE__ */ Concur_React_DOM.a(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var button = /* #__PURE__ */ Concur_React_DOM.button(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Concur_React_Props.functorProps);
var p = /* #__PURE__ */ Concur_React_DOM.p(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var input = /* #__PURE__ */ Concur_React_DOM.input(Concur_Core_LiftWidget.liftWidgetWidget);
var details = /* #__PURE__ */ Concur_React_DOM.details(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var summary$prime = /* #__PURE__ */ Concur_React_DOM["summary$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var h1 = /* #__PURE__ */ Concur_React_DOM.h1(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Concur_Core_Types.applicativeWidget);
var bind = /* #__PURE__ */ Control_Bind.bind(Concur_Core_Types.bindWidget);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(/* #__PURE__ */ Concur_Core_Types.monadEffectWidget(Data_Monoid.monoidArray));
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Concur_Core_Types.bindWidget);
var CreateAttachment = /* #__PURE__ */ (function () {
    function CreateAttachment(value0) {
        this.value0 = value0;
    };
    CreateAttachment.create = function (value0) {
        return new CreateAttachment(value0);
    };
    return CreateAttachment;
})();
var RemoveAttachment = /* #__PURE__ */ (function () {
    function RemoveAttachment(value0) {
        this.value0 = value0;
    };
    RemoveAttachment.create = function (value0) {
        return new RemoveAttachment(value0);
    };
    return RemoveAttachment;
})();
var AttachmentsChanged = /* #__PURE__ */ (function () {
    function AttachmentsChanged(value0) {
        this.value0 = value0;
    };
    AttachmentsChanged.create = function (value0) {
        return new AttachmentsChanged(value0);
    };
    return AttachmentsChanged;
})();
var AttachmentsRequest = /* #__PURE__ */ (function () {
    function AttachmentsRequest(value0) {
        this.value0 = value0;
    };
    AttachmentsRequest.create = function (value0) {
        return new AttachmentsRequest(value0);
    };
    return AttachmentsRequest;
})();
var UploadAttachment = /* #__PURE__ */ (function () {
    function UploadAttachment() {

    };
    UploadAttachment.value = new UploadAttachment();
    return UploadAttachment;
})();
var DeleteAttachment = /* #__PURE__ */ (function () {
    function DeleteAttachment(value0) {
        this.value0 = value0;
    };
    DeleteAttachment.create = function (value0) {
        return new DeleteAttachment(value0);
    };
    return DeleteAttachment;
})();
var StateChange = /* #__PURE__ */ (function () {
    function StateChange(value0) {
        this.value0 = value0;
    };
    StateChange.create = function (value0) {
        return new StateChange(value0);
    };
    return StateChange;
})();
var uploadId = function (state) {
    return state.id + "-attachment-upload";
};
var renderAttachment = function (v) {
    return function (att) {
        return div([ Concur_React_Props.className("attachment") ])([ a([ Concur_React_Props.className("attachment-label"), Concur_React_Props.href(att.url), Concur_React_Props.target("_blank") ])([ text((function () {
            var $34 = att.description === "";
            if ($34) {
                return att.path;
            };
            return att.description;
        })()) ]), div([ Concur_React_Props.className("attachment-meta") ])([ div([ Concur_React_Props.className("attachment-by") ])([ text(att.user.name) ]), div([ Concur_React_Props.className("attachment-time") ])([ text(Internal_Luxon.toRelative(att.created_at)) ]) ]), div([ Concur_React_Props.className("attachment-buttons") ])(Data_Array.catMaybes([ Internal_Util.justIf(att["can"]["delete"])(button([ Concur_React_Props.className("attachment-delete-button btn"), voidRight(new DeleteAttachment(att.id))(Concur_React_Props.onClick) ])([ text(Translate.lookupTranslation("attachment-delete")) ])) ])) ]);
    };
};
var initAttachments = function (v) {
    return {
        id: v.id,
        formId: v.formId,
        attachments: v.attachments,
        description: ""
    };
};
var attachmentForm = function (state) {
    return div([ Concur_React_Props.className("attachment-form") ])([ p([ Concur_React_Props.className("attachment-form-header") ])([ text(Translate.lookupTranslation("attachment-form")) ]), input([ Concur_React_Props["_type"]("file"), Concur_React_Props["_id"](uploadId(state)), voidRight(UploadAttachment.value)(Concur_React_Props.onChange) ]) ]);
};
var renderAttachments = function (v) {
    return details([ Concur_React_Props.key(v.id), Concur_React_Props["_id"](v.id), Concur_React_Props.open(length(v.attachments) > 0) ])([ summary$prime([ h1([ Concur_React_Props.className("attachment-section-heading") ])([ text(Translate.lookupTranslation("attachment-section")) ]) ]), div([ Concur_React_Props.className("attachment-section") ])([ div([ Concur_React_Props.className("attachment-list") ])(map(renderAttachment(v))(v.attachments)), attachmentForm(v) ]) ]);
};
var handleResult = function (v) {
    return function (v1) {
        if (v1 instanceof StateChange) {
            return pure(new AttachmentsChanged(v1.value0));
        };
        if (v1 instanceof DeleteAttachment) {
            return bind(Widgets_Confirmation.confirmModal(renderAttachments(v))(Translate.lookupTranslation("confirm-delete-attachment-title"))(Translate.lookupTranslation("confirm-delete-attachment-primary-button"))(Translate.lookupTranslation("confirm-delete-attachment")))(function (conf) {
                if (conf) {
                    return pure(new AttachmentsRequest(new RemoveAttachment(v1.value0)));
                };
                return pure(new AttachmentsChanged(v));
            });
        };
        if (v1 instanceof UploadAttachment) {
            return bind(liftEffect(Widgets_Upload.getUploadFile(uploadId(v))))(function (file) {
                var name = (function () {
                    var $47 = v.description === "";
                    if ($47) {
                        return Web_File_File.name(file);
                    };
                    return v.description;
                })();
                return pure(new AttachmentsRequest(new CreateAttachment({
                    description: name,
                    file: file
                })));
            });
        };
        throw new Error("Failed pattern match at Widgets.Attachments (line 49, column 1 - line 49, column 85): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var runAttachments = function (state) {
    return bindFlipped(handleResult(state))(renderAttachments(state));
};
export {
    UploadAttachment,
    DeleteAttachment,
    StateChange,
    CreateAttachment,
    RemoveAttachment,
    AttachmentsChanged,
    AttachmentsRequest,
    initAttachments,
    runAttachments,
    handleResult,
    renderAttachments,
    renderAttachment,
    attachmentForm,
    uploadId
};
//# sourceMappingURL=index.js.map
